import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ModalComponent } from '../modal.component';
import { ModalService } from '../../../services/modal/modal.service';
import { Currency } from '../../../shared/models/currency';

@Component({
  selector: 'currency-modal',
  templateUrl: './currency-modal.component.html',
  styleUrls: ['./currency-modal.component.scss'],
})
export class CurrencyModalComponent extends ModalComponent {

  @Input() currencies: Currency[];

  @Output() selectedCurrencyChanged = new EventEmitter<Currency>();

  constructor(protected modalService: ModalService) {
    super(modalService);
  }

  changeCurrency(currency) {
    this.selectedCurrencyChanged.emit(currency);
    this.close();
  }

}
